import { Box } from '@material-ui/system';
import { Outlet } from 'react-router-dom';

import MenuLateral from './components/MenuLateral';
import Center from './components/Center';
import Main from './components/Main';
import Header from './components/Header';

import './App.css';

function App() {
  return (
    <Box sx={{ display: "flex", backgroundColor: '#F8F8F9' }}>
      <MenuLateral />
      <Center>
        <Main>
          <Header />
          <Outlet />
        </Main>
      </Center>
    </Box>
  );
}

export default App;